export default "__VITE_ASSET__iwwxeUrN__"